const zhTranslations = {
  title: "阿尔乔姆·里亚比宁",
  profile: {
    title: "个人简介",
    content: "拥有超过15年行业经验的IT开发者。全栈开发专家，在后端技术和AI实施方面具有深厚知识。为大型企业和初创公司成功交付项目的proven记录，将技术专长与战略思维和领导才能相结合。"
  },
  expertise: {
    title: "专业领域",
    items: [
      "网站开发（网站、信息门户）",
      "企业软件（CRM和ERP系统）",
      "针对独特业务需求的定制软件开发",
      "聊天机器人和AI助手开发",
      "移动应用程序开发",
      "增强现实系统",
      "安全审计和漏洞评估",
      "业务分析和系统分析",
      "使用ML和TensorFlow的大数据处理和分析",
      "用于社交媒体分析的神经网络开发和训练",
      "复杂问题解决和AI研究",
      "微服务架构设计和实施",
      "使用Docker的应用程序容器化",
      "AWS云基础设施集成和部署"
    ]
  },
  skills: {
    title: "核心技能",
    items: [
      "编程语言：Go、Python、TypeScript/JavaScript、PHP（早期经验）",
      "框架：Django、React、GIN",
      "后端开发专精，深入了解服务器架构",
      "全栈开发，专注后端",
      "用户体验/界面设计",
      "项目和开发团队管理",
      "开发中的神经网络实施",
      "适应新技术和方法论",
      "业务流程优化，包括AI系统集成",
      "微服务架构设计和实施",
      "使用Docker的应用程序容器化",
      "AWS应用程序部署和管理",
      "数据库管理：PostgreSQL、MongoDB",
      "高负载系统开发和优化经验"
    ]
  },
  achievements: {
    title: "职业成就",
    items: [
      "通过将AI工具整合到工作流程中，提高开发效率28%",
      "成功为财富500强客户完成超过50个项目",
      "创立高盈利公司RownArts，迅速成为细分市场的领导者",
      "开发并实施创新工作流程优化系统，提高团队生产力32%"
    ]
  },
  experience: {
    title: "工作经验",
    jobs: [
      {
        title: "自由职业者和独立开发者",
        period: "2020 - 至今",
        details: [
          "专注于后端开发（主要使用Go和Python）",
          "为莫斯科国立大学、Sberbank和各种加密项目实施高负载项目",
          "自2021年起实施AI用于开发优化和数据分析",
          "开发和实施创新后端解决方案以优化性能"
        ]
      },
      {
        title: "Neurodoc用户体验/界面专家和React开发者",
        period: "2019",
        details: [
          "在严格的期限内从零开始创建Neurodoc UI/UX系统",
          "使用React开发响应式和无障碍前端解决方案"
        ]
      },
      {
        title: "RedCrypto首席前端开发者",
        period: "2018",
        details: [
          "领导5人开发团队",
          "实施敏捷方法论，将产品发布时间减少40%"
        ]
      },
      {
        title: "RownArts创始人兼团队负责人",
        period: "2013 - 2018",
        details: [
          "将公司从创业发展到15人专业团队",
          "在吸引和保留百加得、大众集团、帕尔门特、MTS、俄罗斯航空、Sber等客户方面发挥关键作用",
          "使用Python、Django和.NET MVC开发创新后端解决方案"
        ]
      },
      {
        title: "Mosaic Media项目经理",
        period: "2013年，5个月",
        details: [
          "成功管理3个主要项目的并行开发",
          "实施质量控制系统，减少57%的错误数量"
        ]
      },
      {
        title: "自由职业者",
        period: "2008 - 2013",
        details: [
          "完成30多个不同复杂度的项目，专注于后端开发",
          "在攻读大学学位期间发展全栈技能，专注后端（PHP，后来是Python）",
          "为各行业客户创建和优化后端系统"
        ]
      }
    ]
  },
  education: {
    title: "教育背景",
    items: [
      {
        institution: "鲍曼莫斯科国立技术大学",
        degree: "机械工程，2013年",
      }
    ]
  },
  additionalEducation: {
    title: "附加教育",
    items: [
      "deeplearning.ai深度学习专业课程，2021年"
    ]
  },
  earlyExperience: {
    title: "早期经验",
    content: "在高中期间为国际客户（AMK technologies、Olga Widman）实施商业项目"
  },
  additionalInfo: {
    title: "附加信息",
    items: [
      "活跃的开源社区成员：Django和TensorFlow项目贡献者",
      "本地IT社区初级开发者的导师",
      "持续自我教育和掌握前沿技术"
    ]
  }
};

export default zhTranslations;